var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassPresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.714355,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    stroke: "#41CD70"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97583 9.45001L5.9775 9.45C6.1116 9.44944 6.24043 9.39633 6.33567 9.30165C6.33575 9.30156 6.33583 9.30148 6.33591 9.3014L10.2806 5.39755L10.2861 5.39212L10.2912 5.38627C10.3749 5.2895 10.419 5.16463 10.414 5.0366C10.409 4.90857 10.3553 4.78753 10.2644 4.69753C10.1735 4.6076 10.0521 4.55525 9.92451 4.55037C9.79693 4.5455 9.67187 4.58841 9.57436 4.67106L9.56848 4.67603L9.56301 4.68145L5.9766 8.22922L4.86564 7.13113L4.86019 7.12574L4.85435 7.12079C4.75684 7.03815 4.63178 6.99523 4.5042 7.00011C4.37661 7.00499 4.25518 7.05733 4.1643 7.14727C4.07336 7.23726 4.01974 7.35831 4.01474 7.48633C4.00974 7.61437 4.05378 7.73924 4.13752 7.83601L4.14258 7.84185L4.14808 7.84729L5.61741 9.3014C5.6175 9.30149 5.61759 9.30158 5.61769 9.30167C5.71291 9.39634 5.84173 9.44944 5.97583 9.45001Z",
    fill: "#3AE180",
    stroke: "#3AE180",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassPresent);
export default __webpack_public_path__ + "static/media/class-present.3f58b70f68ae7f52e5e031d837ff60e1.svg";
export { ForwardRef as ReactComponent };